<template>
    <div id="list-paymentMethods-component" class="w-full flex flex-col">
        <custom-simple-select
            v-if="enabled"
            v-model="option"
            label="Método de pago *"
            :options="selectOptions"
            @change="onInput"
        />
        <div v-else class="flex flex-col">
            <strong>Modo de pago </strong>
            <span
                class="mt-2 ml-2"
                :class="$data.$paymentMethodsMessageClass[itemCurrent]"
            >
                {{ $data.$paymentMethods[itemCurrent] }}
            </span>
        </div>
    </div>
</template>

<script>
import {
    paymentMethods,
    paymentMethodsMessageClass
} from "@/common/fields/orders-payment-methods";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "PaymentMethodSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "pending",
            type: String,
            require: true
        },
        enabled: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        $paymentMethods: paymentMethods,
        $paymentMethodsMessageClass: paymentMethodsMessageClass
    }),
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$paymentMethods).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
